import React, { useState, useEffect } from 'react';
import './InterestsPage.css';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import DashboardLayout from '../Dashboard/layout';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import { Form } from 'react-bootstrap';

const EditInterestsPage = () => {
  const { interestsId } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    status: '',
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null); // State for image preview
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInterestsData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/admin/interests/${interestsId}`
        );
        console.log('image',response);
        
        const data = response.data;
        setFormData({
          name: data.name,
          status: data.status,
          image: null,
        });
        // If there's an existing image, set the preview
        setImagePreview(data.icon ? data.icon : null);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching interests data:', error);
        setError('Failed to fetch interest data.');
        setLoading(false);
      }
    };

    if (interestsId) {
      fetchInterestsData();
    }
  }, [interestsId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Update image and show preview immediately
      setFormData((prevData) => ({
        ...prevData,
        image: file,
      }));
      setImagePreview(URL.createObjectURL(file)); // Create the preview
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formDataToSubmit = new FormData();
      formDataToSubmit.append('name', formData.name);
      formDataToSubmit.append('status', formData.status);
      if (formData.image) {
        formDataToSubmit.append('image', formData.image);
      }

      await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/admin/interests/${interestsId}`,
        formDataToSubmit
      );

      setLoading(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Interest updated successfully!',
      });
      navigate('/interests');
    } catch (error) {
      console.error('Error updating interest:', error);
      setError('Failed to update interest. Please try again later.');
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update interest. Please try again later.',
      });
    }
  };

  return (
    <DashboardLayout>
      <section className="MainDivSec">

        <Headings headspan="Edit" hedtext="Interests " />

        <div className="AdduserFormDiv">
          {error && <p className="error-message">{error}</p>}
          {loading ? (
            <p className="Loadingpara">Loading...</p>
          ) : (
            <Form onSubmit={handleSubmit}>
              <div className="FormGroupDiv">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter Interest name"
                  required
                />
              </div>

              <div className="FormGroupDiv">
                <label htmlFor="status">Status:</label>
                <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select status</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>

              <div className="FormGroupDiv">
                <label htmlFor="image">Upload Icon Image:</label>
                <input
                  type="file"
                  id="image"
                  name="image"
                  accept="image/*" // Ensures only image files can be selected
                  onChange={handleImageChange}
                />
              </div>

              {imagePreview && (
                <div className="image-preview">
                  <p>Image Preview:</p>
                  <img
                    src={imagePreview}
                    alt="Image Preview"
                    style={{
                      width: '150px',
                      height: '150px',
                      marginTop: '10px',
                      borderRadius: '8px',
                    }}
                  />
                </div>
              )}

              <div className="SubMit">
                <button type="submit" disabled={loading}>
                  {loading ? 'Updating...' : 'Update Interest'}
                </button>
              </div>
            </Form>
          )}
        </div>
      </section>
    </DashboardLayout>
  );
};

export default EditInterestsPage;
